"use client";

import dynamic from "next/dynamic";
import { DisplayZoomSync } from "@/components/display-zoom-sync";
import { PremiumProvider } from "@/components/premium-provider";
import { ThemeSync } from "@/components/theme-sync";

// AppPage は localStorage / window.location などクライアント専用 API を useState 初期値で参照しており、
// SSR でレンダーすると hydration mismatch (React #418) を起こす。
// 静的エクスポートでは HTML を空にしてクライアントマウント後にのみ描画する。
const AppPage = dynamic(() => import("@/components/app-page"), { ssr: false });

export default function AppPageClient() {
  return (
    <>
      {/* 表示倍率 (AppSettings.displayZoom) を DOM に反映する。描画はしない */}
      <DisplayZoomSync />
      {/* 配色テーマ (AppSettings.colorTheme) を DOM に反映する。描画はしない */}
      <ThemeSync />
      {/* クラウド同期 (Premium) の判定。ゲスト・未認証には何もしない */}
      <PremiumProvider>
        <AppPage />
      </PremiumProvider>
    </>
  );
}
